import { DEFAULT_LOCALE, DEFAULT_PARTNER } from "@pandas/core-ui";
import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/")({
	beforeLoad: () => {
		throw redirect({
			to: "/$locale/$partner",
			params: { locale: DEFAULT_LOCALE, partner: DEFAULT_PARTNER },
		});
	},
});
